export const HasStatementProcesses = ({ props }) => ([
  { text: 'Stellungnahme angefordert', value: '==0' },
  { text: 'Stellungnahme angefordert / Mitteilung gemacht', value: '!=null' },
  { text: 'Mitteilung gemacht', value: '==1' },
  { text: 'Stellungnahme nicht angefordert', value: '::null' },
])
